// ─────────────────────────────────────────────────────────────────────────────
// CARDVENDOR CONFIGURATION
// Edit this file with your own values before deploying.
// ─────────────────────────────────────────────────────────────────────────────

const CONFIG = {
  // ── Google OAuth Client ID ──────────────────────────────────────────────────
  GOOGLE_CLIENT_ID: "299045344755-ruqth5vmukno8gs56f2kc29abaendaqa.apps.googleusercontent.com",

  // ── Business Rules ──────────────────────────────────────────────────────────
  TRADE_CREDIT_RATE: 0.80,

  // ── Left Nav Icons ──────────────────────────────────────────────────────────
  // Replace these paths with your own .svg or .png files. Put the image files
  // in /public/nav-icons/ (or any path you prefer — just update the strings
  // below to match). If a file is missing or fails to load, the app falls
  // back to the emoji shown in the comment so the nav never breaks.
  NAV_ICONS: {
    dashboard:  "/nav-icons/dashboard.svg",   // fallback: 📊
    inventory:  "/nav-icons/inventory.svg",   // fallback: 📦
    lots:       "/nav-icons/lots.svg",        // fallback: 📁
    crm:        "/nav-icons/crm.svg",         // fallback: 👥
    consignors: "/nav-icons/consignors.svg",  // fallback: 💎 (kept for backwards compat)
    buyers:     "/nav-icons/buyers.svg",      // fallback: 👥 (kept for backwards compat)
    shows:      "/nav-icons/shows.svg",       // fallback: 🎪
    reports:    "/nav-icons/reports.svg",     // fallback: 📈
    import:     "/nav-icons/imports.svg",     // fallback: ⬆
    settings:   "/nav-icons/settings.svg",    // fallback: ⚙
    help:       "/nav-icons/help-icon.svg",   // fallback: ❓
    admin:       "/nav-icons/admin.svg",      // fallback: ❓
  },
  CASH_BUY_RATE:    0.70,
  BREAKEVEN_BUFFER: 0.15,

  // ── Popular Pokémon Tiers ────────────────────────────────────────────────────
  POPULAR_POKEMON: {
    tier1: [
      "Pikachu", "Charizard", "Mewtwo", "Mew",
      "Gengar", "Eevee", "Umbreon", "Sylveon", "Espeon",
      "Squirtle", "Bulbasaur", "Snorlax", "Gyarados",
      "Dragonite", "Lapras", "Metagross", "Arcanine",
    ],
    tier2: [
      "Lucario", "Greninja", "Rayquaza", "Gardevoir",
      "Mimikyu", "Blaziken", "Flygon", "Mudkip",
      "Typhlosion", "Riolu", "Tyranitar", "Piplup", "Fuecoco",
    ],
  },

  // ── Pokemon Sets with release dates ─────────────────────────────────────────
  // Each entry has a name (used in dropdowns) and released (YYYY-MM-DD).
  // Sets without a known exact date use the 1st of the month as an approximation.
  // Add new sets to the TOP of this list as they release.
  POKEMON_SETS: [
    { name: "ME: 30th Celebration", released: "2026-09-16" },
    { name: "XY - Ancient Origins", released: "2015-08-12" },
    { name: "Ancient Roar", released: "2023-10-01" },
    { name: "Aquapolis", released: "2003-01-15" },
    { name: "Arceus", released: "2009-11-04" },
    { name: "ME: Ascended Heroes", released: "2026-01-30" },
    { name: "SWSH10: Astral Radiance", released: "2022-05-27" },
    { name: "Base Set", released: "1999-01-09" },
    { name: "Base Set 2", released: "2000-02-24" },
    { name: "Battle Academy", released: "2022-03-25" },
    { name: "Battle Partners", released: "2025-01-01" },
    { name: "SWSH05: Battle Styles", released: "2021-03-19" },
    { name: "Black and White", released: "2011-04-25" },
    { name: "Black and White Promos", released: "2011-04-01" },
    { name: "SV: Black Bolt", released: "2025-07-18" },
    { name: "Boundaries Crossed", released: "2012-11-07" },
    { name: "XY - BREAKpoint", released: "2016-02-03" },
    { name: "XY - BREAKthrough", released: "2015-11-04" },
    { name: "SWSH09: Brilliant Stars", released: "2022-02-25" },
    { name: "SM - Burning Shadows", released: "2017-08-04" },
    { name: "Call of Legends", released: "2011-02-09" },
    { name: "Celebrations", released: "2021-10-08" },
    { name: "Celebrations: Classic Collection", released: "2021-10-08" },
    { name: "SM - Celestial Storm", released: "2018-08-03" },
    { name: "Champion's Path", released: "2020-09-25" },
    { name: "ME04: Chaos Rising", released: "2026-05-22" },
    { name: "SWSH06: Chilling Reign", released: "2021-06-18" },
    { name: "Clay Burst", released: "2023-04-01" },
    { name: "SM - Cosmic Eclipse", released: "2019-11-01" },
    { name: "Crimson Haze", released: "2024-03-01" },
    { name: "SM - Crimson Invasion", released: "2017-11-03" },
    { name: "SWSH: Crown Zenith", released: "2023-01-20" },
    { name: "EX Crystal Guardians", released: "2006-08-30" },
    { name: "Cyber Judge", released: "2024-01-01" },
    { name: "Dark Explorers", released: "2012-05-09" },
    { name: "SWSH03: Darkness Ablaze", released: "2020-08-14" },
    { name: "Deck Exclusives", released: "2016-12-01" },
    { name: "EX Delta Species", released: "2005-10-31" },
    { name: "EX Deoxys", released: "2005-02-14" },
    { name: "SV10: Destined Rivals", released: "2025-05-30" },
    { name: "Detective Pikachu", released: "2019-03-29" },
    { name: "Diamond and Pearl", released: "2007-05-23" },
    { name: "Double Crisis", released: "2015-03-25" },
    { name: "EX Dragon", released: "2003-11-24" },
    { name: "EX Dragon Frontiers", released: "2006-11-08" },
    { name: "Dragon Majesty", released: "2018-09-07" },
    { name: "Dragons Exalted", released: "2012-08-15" },
    { name: "EX Emerald", released: "2005-05-09" },
    { name: "Emerging Powers", released: "2011-08-31" },
    { name: "XY - Evolutions", released: "2016-11-02" },
    { name: "SWSH07: Evolving Skies", released: "2021-08-27" },
    { name: "Expedition", released: "2002-09-15" },
    { name: "XY - Fates Collide", released: "2016-05-02" },
    { name: "EX FireRed & LeafGreen", released: "2004-08-30" },
    { name: "XY - Flashfire", released: "2014-05-07" },
    { name: "SM - Forbidden Light", released: "2018-05-04" },
    { name: "Fossil", released: "1999-10-10" },
    { name: "XY - Furious Fists", released: "2014-08-13" },
    { name: "SWSH08: Fusion Strike", released: "2021-11-12" },
    { name: "Future Flash", released: "2023-10-01" },
    { name: "Generations", released: "2016-02-22" },
    { name: "Great Encounters", released: "2008-02-13" },
    { name: "SM - Guardians Rising", released: "2017-05-05" },
    { name: "Gym Challenge", released: "2000-10-16" },
    { name: "Gym Heroes", released: "2000-08-14" },
    { name: "HeartGold & SoulSilver", released: "2010-02-10" },
    { name: "Hidden Fates", released: "2019-08-23" },
    { name: "EX Hidden Legends", released: "2004-06-14" },
    { name: "EX Holon Phantoms", released: "2006-05-03" },
    { name: "SV09: Journey Together", released: "2025-03-28" },
    { name: "Jungle", released: "1999-06-16" },
    { name: "EX Legend Maker", released: "2006-02-13" },
    { name: "Legendary Treasures", released: "2013-11-06" },
    { name: "Legends Awakened", released: "2008-08-20" },
    { name: "SWSH11: Lost Origin Trainer Gallery", released: "2022-09-09" },
    { name: "SM - Lost Thunder", released: "2018-11-02" },
    { name: "Majestic Dawn", released: "2008-05-21" },
    { name: "Mask of Change", released: "2024-04-01" },
    { name: "McDonald's 2011", released: "2011-06-01" },
    { name: "McDonald's 2012", released: "2012-06-01" },
    { name: "McDonald's 2013", released: "2013-06-01" },
    { name: "McDonald's 2014", released: "2014-06-01" },
    { name: "McDonald's 2015", released: "2015-06-01" },
    { name: "McDonald's 2016", released: "2016-06-01" },
    { name: "McDonald's 2017", released: "2017-06-01" },
    { name: "McDonald's 2018", released: "2018-06-01" },
    { name: "McDonald's 2019", released: "2019-06-01" },
    { name: "McDonald's 2022", released: "2022-06-01" },
    { name: "McDonald's 2023", released: "2023-06-01" },
    { name: "McDonald's 2024", released: "2024-06-01" },
    { name: "McDonald's 2025", released: "2025-06-01" },
    { name: "McDonald's 25th Anniversary (2021)", released: "2021-11-01" },
    { name: "ME01: Mega Evolution", released: "2025-09-26" },
    { name: "Mega Symphonia", released: "2025-08-01" },
    { name: "Mysterious Treasures", released: "2007-08-22" },
    { name: "Neo Destiny", released: "2002-02-28" },
    { name: "Neo Discovery", released: "2001-06-01" },
    { name: "Neo Genesis", released: "2000-12-16" },
    { name: "Neo Revelation", released: "2001-09-21" },
    { name: "Next Destinies", released: "2012-02-08" },
    { name: "Night Wanderer", released: "2024-06-01" },
    { name: "Noble Victories", released: "2011-11-16" },
    { name: "SV03: Obsidian Flames", released: "2023-08-11" },
    { name: "SV02: Paldea Evolved", released: "2023-06-09" },
    { name: "SV: Paldean Fates", released: "2024-01-26" },
    { name: "Paradise Dragona", released: "2024-06-01" },
    { name: "SV04: Paradox Rift", released: "2023-11-03" },
    { name: "ME03: Perfect Order", released: "2026-03-27" },
    { name: "ME02: Phantasmal Flames", released: "2025-11-14" },
    { name: "XY - Phantom Forces", released: "2014-11-05" },
    { name: "ME05: Pitch Black", released: "2026-07-17" },
    { name: "Plasma Blast", released: "2013-08-14" },
    { name: "Plasma Freeze", released: "2013-05-08" },
    { name: "Plasma Storm", released: "2013-02-06" },
    { name: "Platinum", released: "2009-02-11" },
    { name: "Play! Pokemon Prize Pack Series 3", released: "2022-01-01" },
    { name: "Play! Pokemon Prize Pack Series 4", released: "2023-01-01" },
    { name: "Play! Pokemon Prize Pack Series 5", released: "2024-01-01" },
    { name: "Pokemon GO", released: "2022-07-01" },
    { name: "Pokemon Legendary Collection", released: "2002-05-24" },
    { name: "EX Power Keepers", released: "2007-02-14" },
    { name: "XY - Primal Clash", released: "2015-02-04" },
    { name: "SV: Prismatic Evolutions", released: "2025-01-17" },
    { name: "Raging Surf", released: "2023-09-01" },
    { name: "SWSH02: Rebel Clash", released: "2020-05-01" },
    { name: "Rising Rivals", released: "2009-05-16" },
    { name: "XY - Roaring Skies", released: "2015-05-06" },
    { name: "EX Ruby and Sapphire", released: "2003-07-01" },
    { name: "Ruler of the Black Flame", released: "2023-07-01" },
    { name: "EX Sandstorm", released: "2003-09-18" },
    { name: "Scarlet & Violet", released: "2023-03-31" },
    { name: "SV: Scarlet & Violet 151", released: "2023-09-22" },
    { name: "Scarlet & Violet Promos", released: "2023-03-01" },
    { name: "Scarlet ex", released: "2023-01-01" },
    { name: "Secret Wonders", released: "2007-11-07" },
    { name: "Shining Fates", released: "2021-02-19" },
    { name: "Shining Legends", released: "2017-10-06" },
    { name: "Shiny Treasure ex", released: "2023-12-01" },
    { name: "SV: Shrouded Fable", released: "2024-08-02" },
    { name: "SWSH12: Silver Tempest", released: "2022-11-11" },
    { name: "Skyridge", released: "2003-05-12" },
    { name: "Snow Hazard", released: "2023-04-01" },
    { name: "XY - Steam Siege", released: "2016-08-03" },
    { name: "SV07: Stellar Crown", released: "2024-09-13" },
    { name: "Stellar Miracle", released: "2024-07-01" },
    { name: "Stormfront", released: "2008-11-05" },
    { name: "Sun & Moon", released: "2017-02-03" },
    { name: "Sun & Moon Promos", released: "2017-02-01" },
    { name: "Super Electric Breaker", released: "2024-09-01" },
    { name: "Supreme Victors", released: "2009-08-19" },
    { name: "SV08: Surging Sparks", released: "2024-11-08" },
    { name: "Sword & Shield", released: "2020-02-07" },
    { name: "Sword & Shield Promos", released: "2020-02-01" },
    { name: "EX Team Magma vs Team Aqua", released: "2004-03-15" },
    { name: "Team Rocket", released: "2000-04-24" },
    { name: "EX Team Rocket Returns", released: "2004-11-08" },
    { name: "SM - Team Up", released: "2019-02-01" },
    { name: "SV05: Temporal Forces", released: "2024-03-22" },
    { name: "Terastal Festival ex", released: "2024-10-01" },
    { name: "Trick or Trade 2023", released: "2023-09-01" },
    { name: "Trick or Trade 2024", released: "2024-09-01" },
    { name: "Triplet Beat", released: "2023-03-01" },
    { name: "Triumphant", released: "2010-11-03" },
    { name: "SV06: Twilight Masquerade", released: "2024-05-24" },
    { name: "SM - Ultra Prism", released: "2018-02-02" },
    { name: "SM - Unbroken Bonds", released: "2019-05-03" },
    { name: "Undaunted", released: "2010-08-18" },
    { name: "SM - Unified Minds", released: "2019-08-02" },
    { name: "Unleashed", released: "2010-05-12" },
    { name: "EX Unseen Forces", released: "2005-08-22" },
    { name: "Violet ex", released: "2023-01-01" },
    { name: "SWSH04: Vivid Voltage", released: "2020-11-13" },
    { name: "SV: White Flare", released: "2025-07-18" },
    { name: "Wild Force", released: "2024-01-01" },
    { name: "WoTC Promo", released: "1999-01-01" },
    { name: "XY", released: "2014-02-05" },
    { name: "XY Promos", released: "2014-02-01" },
  ],

  // ── Chinese Exclusive Sets ──────────────────────────────────────────────────
  // Only shown in the Set dropdown when Language is set to Chinese
  CHINESE_SETS: [
    "Ancient Roar Chinese",
    "Azure Shadows",
    "Battle Party: Shared Dream Part 1",
    "Battle Party: Shared Dream Part 2",
    "Battle Party: Shining Dream Part 1",
    "Bonus Round",
    "Brave Stars CS5A",
    "Brave Stars CS5B",
    "Collect 151",
    "Crimson Haze Chinese",
    "Cyber Judge Chinese",
    "Dragon Storm",
    "Eevee Heroes Chinese",
    "Fearless Terastal",
    "Future Flash Chinese",
    "Gem Pack Vol. 1",
    "Gem Pack Vol. 2",
    "Gem Pack Vol. 3",
    "Gem Pack Vol. 4",
    "Gem Pack Vol. 5",
    "Night Wanderer Chinese",
    "Nine Colors Gathering: Friend",
    "Nine Colors Gathering: Source",
    "Pokémon GO Chinese",
    "Raging Surf Chinese",
    "Scorching Skies",
    "Shadow of Glory",
    "Shining Synergy (Summon)",
    "Start Deck 100 China Edition",
    "Sword & Shield High-Class Gift Box",
    "Tag Team All Stars Chinese",
    "VMAX Climax Chinese",
    "Wild Force Chinese",



  ],
  // ── Japanese Exclusive Sets ──────────────────────────────────────────────────
  // Only shown in the Set dropdown when Language is set to Japanese
  JAPANESE_SETS: [
    "151",
    "Abyss Eye",
    "Alter Genesis",
    "Ancient Roar",
    "Battle Partners",
    "Battle Region",
    "Black Bolt",
    "Blue Sky Stream",
    "Clay Burst",
    "Crimson Haze",
    "Cyber Judge",
    "Dark Phantasma",
    "Double Blaze",
    "Dream League",
    "Eevee Heroes",
    "Expansion Pack",
    "Fusion Arts",
    "Future Flash",
    "Glory of Team Rocket",
    "Gold, Silver, to a New World",
    "GX Tag All Stars",
    "Incandescent Arcana",
    "Inferno X",
    "Jet Black Geist",
    "Jet-Black Spirit",
    "Legendary Heartbeat",
    "Lost Abyss",
    "Mask of Change",
    "Matchless Fighters",
    "MEGA Dream ex",
    "Mega Brave",
    "Mega Symphonia",
    "M3 Nihil Zero",
    "Miracle Twin",
    "Miracle Twins",
    "Night Wanderer",
    "Ninja Spinner",
    "Paradigm Trigger",
    "Paradise Dragona",
    "Pokemon 151",
    "Pokemon GO (Japanese)",
    "Pokémon Card 151",
    "Raging Surf",
    "Rapid Strike Master",
    "Remix Bout",
    "Ruler of the Black Flame",
    "Scarlet & Violet Promo JP",
    "Scarlet ex",
    "Shiny Star V",
    "Shiny Treasure ex",
    "Silver Lance",
    "Single Strike Master",
    "Snow Hazard",
    "Space Juggler",
    "Star Birth",
    "Stellar Miracle",
    "Sun & Moon Promos JP",
    "Super Electric Breaker",
    "Sword & Shield Promots",
    "Tag Team All Stars",
    "Terastal Festival ex",
    "Time Gazer",
    "Triple Beat",
    "Triplet Beat",
    "Ultra Shiny GX",
    "Violet ex",
    "VMAX Climax",
    "VSTAR Universe",
    "White Flare",
    "Wild Force",



  ],

  // ── Language-specific Rarities ───────────────────────────────────────────────
  RARITIES_ENGLISH: [
    "Common","Uncommon","Rare","Holo Rare","Reverse Holo","Double Rare",
    "Ultra Rare","Illustration Rare","Special Illustration Rare","Mega Attack Rare",
    "Secret Rare","Hyper Rare","Gold Rare","Full Art","Alternate Art",
    "Shiny Holo","Trainer Gallery","Galarian Gallery","Promo","Classic Collection",
  ],
  RARITIES_JAPANESE: [
    // Base rarities
    "Common","Uncommon","Rare","Holo Rare",
    // Classic era
    "Double Black Star","Triple Black Star","Shining Holofoil","Gold Star",
    "Crystal","LV.X","LEGEND","Prime",
    // EX / XY era
    "EX Rare","ACE SPEC Rare","BREAK Rare",
    // SM era
    "Prism Star","GX Rare","Tag Team GX Rare",
    // Sword & Shield era
    "V Rare","VMAX Rare","VSTAR Rare","Amazing Rare","Radiant Rare",
    // Scarlet & Violet / modern
    "Double Rare","Triple Rare","Super Rare","Hyper Rare","Ultra Rare",
    "Trainer Rare","Shiny Rare","Shiny Super Rare",
    // Character / art rarities
    "Character Rare","Character Super Rare","Art Rare","Special Art Rare",
    "Special Illustration Rare",
    // Mega Evolution era
    "Mega Attack Rare","Black White Rare","Mega Ultra Rare",
    "Futuristic Rare",
    // Secret rarities
    "Secret Rare","Shiny Secret Rare","Hyper Secret Rare",
    "Gold Secret Rare",
    // Promo
    "Promotional",
  ],
  RARITIES_CHINESE: [
    "Common","Uncommon","Rare","Double Rare","Triple Rare","Super Rare",
    "Shiny Secret Rare","Ultra Rare","Hyper Rare","Art Rare","Special Art Rare",
    "Character Rare","Character Super Rare","Shiny Rare","Mirror Rare","Promotional",
  ],

  // ── Collectr Set Name Mapping ───────────────────────────────────────────────
  // Maps Collectr's set names → your set names in POKEMON_SETS
  // null = unmatchable (goes to review queue)
  // Add entries here as new Collectr set name variations are discovered
  COLLECTR_SET_MAP: {
    // Promo sets
    "Sword & Shield Promo":          "Sword & Shield Promos",
    "Sword & Shield Promos (JP)":    "Sword & Shield Promos",
    "Scarlet & Violet Promo":        "Scarlet & Violet Promos",
    "Scarlet & Violet Promo JP":     "Scarlet & Violet Promos",
    "Sun & Moon Promo":              "Sun & Moon Promos",
    "XY Promos":                     "XY Promos",
    "WoTC Promo":                    "WoTC Promo",
    // Gallery / Vault subsets → parent set
    "Shining Fates: Shiny Vault":    "Shining Fates",
    "Hidden Fates: Shiny Vault":     "Hidden Fates",
    "Crown Zenith: Galarian Gallery":"SWSH: Crown Zenith",
    "Lost Origin Trainer Gallery":   "Lost Origin",
    "Lost Origin Trainer Gallery":   "Lost Origin",
    "Brilliant Stars Trainer Gallery":"SWSH09: Brilliant Stars",
    "Silver Tempest Trainer Gallery": "SWSH12: Silver Tempest",
    "Astral Radiance Trainer Gallery":"SWSH10: Astral Radiance",
    // Base set name variants
    "Scarlet & Violet Base Set":     "Scarlet & Violet",
    "Sword & Shield Base Set":       "Sword & Shield",
    "Sun & Moon Base Set":           "Sun & Moon",
    "XY Base Set":                   "XY",
    "Base Set (Unlimited)":          "Base Set",
    // 151 variants
    "SV: 151":                       "SV: Scarlet & Violet 151",
    "Pokemon 151":                   "SV: Scarlet & Violet 151",
    // Japanese sets mapped to English equivalents
    "Amazing Volt":                  "SV08: Surging Sparks",
    "Lost Abyss":                    "Lost Origin",
    "MEGA Dream ex":                 "ME01: Mega Evolution",
    "Mega Evolution Promos":         "ME01: Mega Evolution",
    "Night Wanderer":                "SV06: Twilight Masquerade",
    "Mask of Change":                "SV05: Temporal Forces",
    "Crimson Haze":                  "SV: Paldean Fates",
    "Cyber Judge":                   "SV05: Temporal Forces",
    "GG End":                        "SWSH: Crown Zenith",
    "Blue Sky Stream":               "SWSH12: Silver Tempest",
    "Jet Black Geist":               "Lost Origin",
    "Hot Air Arena":                 "SWSH08: Fusion Strike",
    "Shiny Star V":                  "SWSH04: Vivid Voltage",
    "VMAX Climax":                   "VMAX Climax Chinese",
    "Pokemon Go":                    "Pokemon GO",
    "Pokemon GO (Japanese)":         "Pokemon GO",
    // Chinese / Other
    "Collect 151 Hope":              null,  // review queue
    "Miscellaneous Cards & Products": null, // review queue
    "Gem Pack":                      "Gem Pack Vol. 1",
    "Gem Pack 2":                    "Gem Pack Vol. 2",
    "Gem Pack Vol. 4":               "Gem Pack Vol. 4",
    "Gem Pack Vol. 5":               "Gem Pack Vol. 5",
    // McDonald's
    "McDonald's 25th Anniversary Promos": "McDonald's 25th Anniversary (2021)",
    "McDonald's Promos 2024":        "McDonald's 2024",
    "McDonald's Promos 2022":        "McDonald's 2022",
    "McDonald's Promos 2015":        "McDonald's 2015",
    // Misc one-offs → review queue
    "Deck Exclusives":               null,
    "Jumbo Cards":                   null,
    "Battle Academy 2024":           null,
    "POP Series 9":                  null,
    "Trick or Trade BOOster Bundle": null,
    "Ninja Spinner":                 "Ninja Spinner",
    "Mega Brave":                    null,
    "Mega Symphonia":                null,
  },
  // ── LORCANA ───────────────────────────────────────────────────────────────
  LORCANA_SETS: [
    "Archazia's Island",
    "Attack of the Vine!",
    "Azurite Sea",
    "Challenge Set 1",
    "Challenge Set 2",
    "Curators Collection",
    "D23 Collection",
    "D23 Expo",
    "Deep Trouble",
    "Disney Promo",
    "Disney100",
    "Event Promo",
    "Fabled",
    "Hyperia City",
    "Illumineer's Quest: Palace Heist",
    "Into the Inklands",
    "Lorcana League",
    "Promo Set 1",
    "Promo Set 2",
    "Promo Set 3",
    "Ravensburger",
    "Reign of Jafar",
    "Rise of the Floodborn",
    "Shimmering Skies",
    "The First Chapter",
    "Ursula's Return",
    "Whispers in the Well",
    "Wilds Unknown",
    "Winterspell",
  ],

  // ── MAGIC: THE GATHERING (via API TCG) ─────────────────────────────────────
  MAGIC_SETS: [
    "10th Edition",
    "30th Anniversary Edition",
    "30th Anniversary Promos",
    "7th Edition",
    "8th Edition",
    "9th Edition",
    "Adventures in the Forgotten Realms",
    "Aether Revolt",
    "Aetherdrift",
    "AFR Ampersand Promos",
    "Alara Reborn",
    "Alliances",
    "Alpha Edition",
    "Amonkhet",
    "Anthologies",
    "Antiquities",
    "APAC Lands",
    "Apocalypse",
    "Arabian Nights",
    "Archenemy",
    "Archenemy: Duskmourn",
    "Archenemy: Nicol Bolas",
    "Arena Promos",
    "Arena Starter Kit",
    "Art Series: Adventures in the Forgotten Realms",
    "Art Series: Aetherdrift",
    "Art Series: Avatar: The Last Airbender",
    "Art Series: Bloomburrow",
    "Art Series: Commander Legends: Battle for Baldur's Gate",
    "Art Series: Commander Masters",
    "Art Series: Dominaria United",
    "Art Series: Duskmourn: House of Horror",
    "Art Series: Edge of Eternities",
    "Art Series: FINAL FANTASY",
    "Art Series: Foundations",
    "Art Series: Innistrad Remastered",
    "Art Series: Innistrad: Crimson Vow",
    "Art Series: Innistrad: Midnight Hunt",
    "Art Series: Kaldheim",
    "Art Series: Kamigawa: Neon Dynasty",
    "Art Series: Lorwyn Eclipsed",
    "Art Series: March of the Machine",
    "Art Series: Marvel Super Heroes",
    "Art Series: Marvel's Spider-Man",
    "Art Series: Modern Horizons",
    "Art Series: Modern Horizons 2",
    "Art Series: Modern Horizons 3",
    "Art Series: Murders at Karlov Manor",
    "Art Series: Outlaws of Thunder Junction",
    "Art Series: Phyrexia: All Will Be One",
    "Art Series: Secrets of Strixhaven",
    "Art Series: Streets of New Capenna",
    "Art Series: Strixhaven",
    "Art Series: Tarkir: Dragonstorm",
    "Art Series: Teenage Mutant Ninja Turtles",
    "Art Series: The Brothers' War",
    "Art Series: The Hobbit",
    "Art Series: The Lost Caverns of Ixalan",
    "Art Series: Universes Beyond: Assassin's Creed",
    "Art Series: Universes Beyond: The Lord of the Rings: Tales of Middle-earth",
    "Art Series: Wilds of Eldraine",
    "Art Series: Zendikar Rising",
    "Astral",
    "Avacyn Restored",
    "Avatar: The Last Airbender",
    "Avatar: The Last Airbender: Eternal-Legal",
    "Battle for Zendikar",
    "Battle Royale Box Set",
    "Battlebond",
    "Beatdown Box Set",
    "Beta Edition",
    "Betrayers of Kamigawa",
    "Bloomburrow",
    "Born of the Gods",
    "Box Sets",
    "Buy-A-Box Promos",
    "Challenger Decks",
    "Champions of Kamigawa",
    "Champs Promos",
    "Chronicles",
    "Classic Sixth Edition",
    "Coldsnap",
    "Coldsnap Theme Deck Reprints",
    "Collector's Edition",
    "Commander",
    "Commander 2013",
    "Commander 2014",
    "Commander 2015",
    "Commander 2016",
    "Commander 2017",
    "Commander 2018",
    "Commander 2019",
    "Commander 2020",
    "Commander 2021",
    "Commander Anthology",
    "Commander Anthology Volume II",
    "Commander Collection: Black",
    "Commander Collection: Green",
    "Commander Legends",
    "Commander Legends: Battle for Baldur's Gate",
    "Commander Masters",
    "Commander's Arsenal",
    "Commander: Adventures in the Forgotten Realms",
    "Commander: Aetherdrift",
    "Commander: Bloomburrow",
    "Commander: Dominaria United",
    "Commander: Duskmourn: House of Horror",
    "Commander: Edge of Eternities",
    "Commander: FINAL FANTASY",
    "Commander: Foundations",
    "Commander: Innistrad: Crimson Vow",
    "Commander: Innistrad: Midnight Hunt",
    "Commander: Kaldheim",
    "Commander: Kamigawa: Neon Dynasty",
    "Commander: Lorwyn Eclipsed",
    "Commander: March of the Machine",
    "Commander: Marvel Super Heroes",
    "Commander: Modern Horizons 3",
    "Commander: Murders at Karlov Manor",
    "Commander: Outlaws of Thunder Junction",
    "Commander: Phyrexia: All Will Be One",
    "Commander: Reality Fracture",
    "Commander: Secrets of Strixhaven",
    "Commander: Star Trek",
    "Commander: Streets of New Capenna",
    "Commander: Tarkir: Dragonstorm",
    "Commander: Teenage Mutant Ninja Turtles",
    "Commander: The Brothers' War",
    "Commander: The Lord of the Rings: Tales of Middle-earth",
    "Commander: The Lost Caverns of Ixalan",
    "Commander: Wilds of Eldraine",
    "Commander: Zendikar Rising",
    "Conflux",
    "Conspiracy",
    "Conspiracy: Take the Crown",
    "Core Set 2019",
    "Core Set 2020",
    "Core Set 2021",
    "Dark Ascension",
    "Darksteel",
    "Deckmasters Garfield vs Finkel",
    "Dissension",
    "Dominaria",
    "Dominaria Remastered",
    "Dominaria United",
    "Double Masters",
    "Double Masters 2022",
    "Dragon's Maze",
    "Dragons of Tarkir",
    "Duel Decks",
    "Duel Decks: Ajani vs. Nicol Bolas",
    "Duel Decks: Anthology",
    "Duel Decks: Blessed vs. Cursed",
    "Duel Decks: Divine vs. Demonic",
    "Duel Decks: Elspeth vs. Kiora",
    "Duel Decks: Elspeth vs. Tezzeret",
    "Duel Decks: Elves vs. Goblins",
    "Duel Decks: Elves vs. Inventors",
    "Duel Decks: Garruk vs. Liliana",
    "Duel Decks: Heroes vs. Monsters",
    "Duel Decks: Izzet vs. Golgari",
    "Duel Decks: Jace vs. Chandra",
    "Duel Decks: Jace vs. Vraska",
    "Duel Decks: Knights vs. Dragons",
    "Duel Decks: Merfolk vs. Goblins",
    "Duel Decks: Mind vs. Might",
    "Duel Decks: Nissa vs. Ob Nixilis",
    "Duel Decks: Phyrexia vs. the Coalition",
    "Duel Decks: Sorin vs. Tibalt",
    "Duel Decks: Speed vs. Cunning",
    "Duel Decks: Venser vs. Koth",
    "Duel Decks: Zendikar vs. Eldrazi",
    "Duels of the Planeswalkers",
    "Duskmourn: House of Horror",
    "Edge of Eternities",
    "Edge of Eternities: Stellar Sights",
    "Eldritch Moon",
    "Eternal Masters",
    "European Lands",
    "Eventide",
    "Exodus",
    "Explorers of Ixalan",
    "Fallen Empires",
    "Fate Reforged",
    "Fifth Dawn",
    "Fifth Edition",
    "FINAL FANTASY",
    "FINAL FANTASY: Through the Ages",
    "FNM Promos",
    "Foundations",
    "Foundations Jumpstart",
    "Fourth Edition",
    "Fourth Edition (Foreign Black Border)",
    "Fourth Edition (Foreign White Border)",
    "From the Vault: Angels",
    "From the Vault: Annihilation",
    "From the Vault: Dragons",
    "From the Vault: Exiled",
    "From the Vault: Legends",
    "From the Vault: Lore",
    "From the Vault: Realms",
    "From the Vault: Relics",
    "From the Vault: Transform",
    "From the Vault: Twenty",
    "Future Sight",
    "Game Day & Store Championship Promos",
    "Gatecrash",
    "Gift Boxes and Promos",
    "Global Series Jiang Yanggu & Mu Yanling",
    "Grand Prix Promos",
    "Guildpact",
    "Guilds of Ravnica",
    "Guilds of Ravnica: Guild Kits",
    "Guru Lands",
    "Hero's Path Promos",
    "Homelands",
    "Hour of Devastation",
    "Ice Age",
    "Iconic Masters",
    "Ikoria: Lair of Behemoths",
    "Impact Beyond Dimensions",
    "Innistrad",
    "Innistrad Remastered",
    "Innistrad: Crimson Vow",
    "Innistrad: Double Feature",
    "Innistrad: Midnight Hunt",
    "International Edition",
    "Introductory Two-Player Set",
    "Invasion",
    "Ixalan",
    "JingHe Age Token Cards",
    "Journey Into Nyx",
    "Judge Promos",
    "Judgment",
    "Jumpstart",
    "Jumpstart 2022",
    "Junior Series Promos",
    "Kaladesh",
    "Kaldheim",
    "Kamigawa: Neon Dynasty",
    "Khans of Tarkir",
    "Launch Party & Release Event Promos",
    "Launch Party Cards",
    "League Promos",
    "Legends",
    "Legions",
    "Lorwyn",
    "Lorwyn Eclipsed",
    "Magic 2010 (M10)",
    "Magic 2011 (M11)",
    "Magic 2012 (M12)",
    "Magic 2013 (M13)",
    "Magic 2014 (M14)",
    "Magic 2015 (M15)",
    "Magic Encyclopedia 2005 (Salvat/Hachette)",
    "Magic Encyclopedia 2011 (Salvat)",
    "Magic Game Night",
    "Magic Game Night 2019",
    "Magic Game Night: Free-For-All",
    "Magic Modern Event Deck",
    "Magic Origins",
    "Magic Player Rewards",
    "Magic Premiere Shop",
    "Magic: The Gathering Apparel",
    "MagicFest Cards",
    "March of the Machine",
    "March of the Machine: Multiverse Legends",
    "March of the Machine: The Aftermath",
    "Marvel Super Heroes",
    "Marvel Universe Eternal-Legal",
    "Marvel's Spider-Man",
    "Marvel's Spider-Man: Eternal-Legal",
    "Masterpiece Series: Amonkhet Invocations",
    "Masterpiece Series: Kaladesh Inventions",
    "Masters 25",
    "Media Promos",
    "Mercadian Masques",
    "Mirage",
    "Mirrodin",
    "Mirrodin Besieged",
    "Modern Horizons",
    "Modern Horizons 2",
    "Modern Horizons 3",
    "Modern Masters",
    "Modern Masters 2015",
    "Modern Masters 2017",
    "Morningtide",
    "Murders at Karlov Manor",
    "Mystery Booster 2",
    "Mystery Booster 2 Playtest Cards",
    "Mystery Booster Cards",
    "Mystery Booster Commander Edition",
    "Mystery Booster: Convention Edition Exclusives",
    "Mystery Booster: Retail Exclusives",
    "Mythic Edition: Guilds of Ravnica",
    "Mythic Edition: Ravnica Allegiance",
    "Mythic Edition: War of the Spark",
    "Nemesis",
    "New Phyrexia",
    "Oath of the Gatewatch",
    "Odyssey",
    "Onslaught",
    "Open House Promos",
    "Outlaws of Thunder Junction",
    "Outlaws of Thunder Junction: Breaking News",
    "Outlaws of Thunder Junction: The Big Score",
    "Oversize Cards",
    "Phyrexia: All Will Be One",
    "Planar Chaos",
    "Planechase",
    "Planechase 2012",
    "Planechase Anthology",
    "Planechase: March of the Machine",
    "Planechase: Universes Beyond: Doctor Who",
    "Planeshift",
    "Planeswalker Event Promos",
    "Play Promos",
    "Ponies: The Galloping",
    "Portal",
    "Portal Second Age",
    "Portal Three Kingdoms",
    "Premium Deck Series: Fire and Lightning",
    "Premium Deck Series: Graveborn",
    "Premium Deck Series: Slivers",
    "Prerelease Cards",
    "Pro Tour Promos",
    "Promo Pack: Adventures in the Forgotten Realms",
    "Promo Pack: Aetherdrift",
    "Promo Pack: Bloomburrow",
    "Promo Pack: Core Set 2020",
    "Promo Pack: Core Set 2021",
    "Promo Pack: Dominaria United",
    "Promo Pack: Duskmourn: House of Horror",
    "Promo Pack: Edge of Eternities",
    "Promo Pack: Ikoria",
    "Promo Pack: Innistrad: Midnight Hunt",
    "Promo Pack: Kaldheim",
    "Promo Pack: Kamigawa: Neon Dynasty",
    "Promo Pack: Lorwyn Eclipsed",
    "Promo Pack: March of the Machine",
    "Promo Pack: Murders at Karlov Manor",
    "Promo Pack: Outlaws of Thunder Junction",
    "Promo Pack: Phyrexia: All Will Be One",
    "Promo Pack: Secrets of Strixhaven",
    "Promo Pack: Streets of New Capenna",
    "Promo Pack: Strixhaven",
    "Promo Pack: Tarkir: Dragonstorm",
    "Promo Pack: The Brothers' War",
    "Promo Pack: The Lost Caverns of Ixalan",
    "Promo Pack: Theros Beyond Death",
    "Promo Pack: Throne of Eldraine",
    "Promo Pack: Wilds of Eldraine",
    "Promo Pack: Zendikar Rising",
    "Prophecy",
    "Ravnica Allegiance",
    "Ravnica Allegiance: Guild Kits",
    "Ravnica Remastered",
    "Ravnica: City of Guilds",
    "Ravnica: Clue Edition",
    "Reality Fracture",
    "Renaissance",
    "Return to Ravnica",
    "Revised Edition",
    "Revised Edition (Foreign Black Border)",
    "Revised Edition (Foreign White Border)",
    "Rise of the Eldrazi",
    "Rivals of Ixalan",
    "Rivals Quick Start Set",
    "Saviors of Kamigawa",
    "Scars of Mirrodin",
    "Scourge",
    "Secret Lair Commander: From Cute to Brute",
    "Secret Lair Commander: Heads I Win, Tails You Lose",
    "Secret Lair Countdown Kit",
    "Secret Lair Drop Series",
    "Secret Lair Series",
    "Secret Lair Showdown",
    "Secrets of Strixhaven",
    "Secrets of Strixhaven: Mystical Archive",
    "Shadowmoor",
    "Shadows over Innistrad",
    "Shards of Alara",
    "Signature Spellbook: Chandra",
    "Signature Spellbook: Gideon",
    "Signature Spellbook: Jace",
    "SLX Cards",
    "Special Guests",
    "Special Occasion",
    "Spellslinger Starter Kit",
    "Standard Showdown Promos",
    "Star Trek",
    "Star Trek: Stardates",
    "Starter 1999",
    "Starter 2000",
    "Starter Commander Decks",
    "Streets of New Capenna",
    "Strixhaven: Mystical Archive",
    "Strixhaven: School of Mages",
    "Stronghold",
    "Summer Magic",
    "Tarkir Dragonfury Promos",
    "Tarkir: Dragonstorm",
    "Teenage Mutant Ninja Turtles",
    "Teenage Mutant Ninja Turtles Source Material",
    "Tempest",
    "The Brothers' War",
    "The Brothers' War: Retro Frame Artifacts",
    "The Dark",
    "The Hobbit",
    "The Hobbit: Eternal-Legal",
    "The List Reprints",
    "The Lost Caverns of Ixalan",
    "Theros",
    "Theros Beyond Death",
    "Throne of Eldraine",
    "Time Spiral",
    "Time Spiral: Remastered",
    "Timeshifted",
    "Torment",
    "Ugin's Fate Promos",
    "Ultimate Masters",
    "Ultimate Masters: Box Toppers",
    "Un-Known Event Playtest Cards",
    "Unfinity",
    "Unglued",
    "Unhinged",
    "Unique and Miscellaneous Promos",
    "Universes Beyond: Assassin's Creed",
    "Universes Beyond: Doctor Who",
    "Universes Beyond: Fallout",
    "Universes Beyond: Jurassic World Collection",
    "Universes Beyond: The Lord of the Rings: Tales of Middle-earth",
    "Universes Beyond: Transformers",
    "Universes Beyond: Warhammer 40,000",
    "Unlimited Edition",
    "Unsanctioned",
    "Unstable",
    "Urza's Destiny",
    "Urza's Legacy",
    "Urza's Saga",
    "Vanguard",
    "Visions",
    "War of the Spark",
    "Weatherlight",
    "Welcome Deck 2016",
    "Welcome Deck 2017",
    "Wilds of Eldraine",
    "Wilds of Eldraine: Enchanting Tales",
    "WMCQ Promo Cards",
    "World Championship Decks",
    "Worldwake",
    "WPN & Gateway Promos",
    "Zendikar",
    "Zendikar Expeditions",
    "Zendikar Rising",
    "Zendikar Rising Expeditions",
  ],

  // ── ONE PIECE (via API TCG) ─────────────────────────────────────────────────
  ONEPIECE_SETS: [
    "500 Years in the Future",
    "500 Years in the Future Pre-Release Cards",
    "A Fist of Divine Speed",
    "A Fist of Divine Speed Release Event Cards",
    "Adventure on Kami's Island",
    "Adventure on Kami's Island Release Event Cards",
    "Awakening of the New Era",
    "Awakening of the New Era: 1st Anniversary Tournament Cards",
    "Carrying On His Will",
    "Carrying On His Will: 3rd Anniversary Tournament Cards",
    "Emperors in the New World",
    "Emperors in the New World: 2nd Anniversary Tournament Cards",
    "Extra Booster: Anime 25th Collection",
    "Extra Booster: Memorial Collection",
    "Extra Booster: One Piece Heroine's Edition Vol. 2",
    "Extra Booster: One Piece Heroines Edition",
    "Kingdoms of Intrigue",
    "Kingdoms of Intrigue Pre-Release Cards",
    "Learn Together Deck Set",
    "Legacy of the Master",
    "Legacy of the Master Release Event Cards",
    "One Piece Collection Sets",
    "One Piece Demo Deck Cards",
    "One Piece Promotion Cards",
    "Paramount War",
    "Paramount War Pre-Release Cards",
    "Pillars of Strength",
    "Pillars of Strength Pre-Release Cards",
    "Premium Booster -The Best-",
    "Premium Booster -The Best- Vol. 2",
    "Revision Pack Cards",
    "Romance Dawn",
    "Royal Blood",
    "Royal Blood Release Event Cards",
    "Set Sail Deck Set",
    "Starter Deck 11: Uta",
    "Starter Deck 12: Zoro and Sanji",
    "Starter Deck 14: 3D2Y",
    "Starter Deck 15: RED Edward.Newgate",
    "Starter Deck 16: GREEN Uta",
    "Starter Deck 17: BLUE Donquixote Doflamingo",
    "Starter Deck 18: PURPLE Monkey.D.Luffy",
    "Starter Deck 19: BLACK Smoker",
    "Starter Deck 1: Straw Hat Crew",
    "Starter Deck 20: YELLOW Charlotte Katakuri",
    "Starter Deck 22: Ace & Newgate",
    "Starter Deck 23: RED Shanks",
    "Starter Deck 24: GREEN Jewelry Bonney",
    "Starter Deck 25: BLUE Buggy",
    "Starter Deck 26: PURPLE/BLACK Monkey.D.Luffy",
    "Starter Deck 27: BLACK Marshall.D.Teach",
    "Starter Deck 28: GREEN/YELLOW Yamato",
    "Starter Deck 29: Egghead",
    "Starter Deck 2: Worst Generation",
    "Starter Deck 31: RED Monkey.D.Luffy",
    "Starter Deck 32: GREEN Roronoa Zoro",
    "Starter Deck 33: BLUE Kuzan",
    "Starter Deck 34: PURPLE Charlotte Katakuri",
    "Starter Deck 35: RED/BLACK Sabo",
    "Starter Deck 36: YELLOW Eustass\"Captain\"Kid",
    "Starter Deck 3: The Seven Warlords of The Sea",
    "Starter Deck 4: Animal Kingdom Pirates",
    "Starter Deck 5: Film Edition",
    "Starter Deck 6: Absolute Justice",
    "Starter Deck 7: Big Mom Pirates",
    "Starter Deck 8: Monkey.D.Luffy",
    "Starter Deck 9: Yamato",
    "Starter Deck EX: Gear 5",
    "Starter Deck EX: Luffy & Ace",
    "Super Pre-Release Starter Deck 1: Straw Hat Crew",
    "Super Pre-Release Starter Deck 2: Worst Generation",
    "Super Pre-Release Starter Deck 3: The Seven Warlords of the Sea",
    "Super Pre-Release Starter Deck 4: Animal Kingdom Pirates",
    "The Azure Sea's Seven",
    "The Azure Sea's Seven Release Event Cards",
    "The Time of Battle",
    "The Time of Battle Release Event Cards",
    "The World's Strongest Warriors",
    "The World's Strongest Warriors Release Event Cards",
    "Two Legends",
    "Two Legends Pre-Release Cards",
    "Ultra Deck: The Three Brothers",
    "Ultra Deck: The Three Captains",
    "Wings of the Captain",
    "Wings of the Captain Pre-Release Cards",
  ],

  // ── YU-GI-OH (via API TCG) ──────────────────────────────────────────────────
  YUGIOH_SETS: [
    "2-Player Starter Set",
    "2002 Collectors Tin",
    "2003 Collectors Tin",
    "2004 Collectors Tin",
    "2005 Collectors Tin",
    "2006 Collectors Tin",
    "2007 Collectors Tin",
    "2008 Collectors Tin",
    "2009 Collectors Tin",
    "2009 Duelist Pack Collection Tin",
    "2010 Collectors Tins",
    "2010 Duelist Pack Collection Tin",
    "2011 Collectors Tins",
    "2011 Duelist Pack Tin",
    "2012 Collectors Tin",
    "2012 Premium Collection Tin",
    "2013 Collectors Tins",
    "2013 Zexal Collection Tin",
    "2014 Mega-Tins",
    "2014 Mega-Tins Mega Pack",
    "2015 Mega-Tins",
    "2015 Mega-Tins Mega Pack",
    "2016 Mega-Tins",
    "2016 Mega-Tins Mega Pack",
    "2017 Mega-Tins",
    "2017 Mega-Tins Mega Pack",
    "2018 Mega-Tins",
    "2018 Mega-Tins Mega Pack",
    "2019 Gold Sarcophagus Tin",
    "2019 Gold Sarcophagus Tin Mega Pack",
    "2020 Tin of Lost Memories",
    "2021 Tin of Ancient Battles",
    "2022 Tin of the Pharaoh's Gods",
    "2025 Mega-Pack",
    "25th Anniversary Rarity Collection",
    "25th Anniversary Rarity Collection II",
    "25th Anniversary Tin: Dueling Heroes",
    "25th Anniversary Tin: Dueling Heroes Mega Pack",
    "25th Anniversary Tin: Dueling Mirrors",
    "25th Anniversary Ultimate Kaiba Set",
    "5D's 2008 English Starter Deck",
    "5D's 2008 Starter Deck",
    "5D's Starter Deck 2009",
    "Absolute Powerforce",
    "Absolute Powerforce: Special Edition",
    "Abyss Rising",
    "Abyss Rising SE",
    "Advanced Demo Deck Extra Pack",
    "Advent Calendar 2011 (Adventskalender)",
    "Advent Calendar 2014 (Adventskalender ZEXAL-Edition)",
    "Advent Calendar 2018",
    "Advent Calendar 2019",
    "Age of Overlord",
    "Alliance Insight",
    "Amazing Defenders",
    "Ancient Guardians",
    "Ancient Prophecy",
    "Ancient Prophecy SE",
    "Ancient Sanctuary",
    "Anniversary Pack",
    "Astral Pack 1",
    "Astral Pack 2",
    "Astral Pack 3",
    "Astral Pack 4",
    "Astral Pack 5",
    "Astral Pack 6",
    "Astral Pack 7",
    "Astral Pack 8",
    "Battle of Chaos",
    "Battle Pack 2: War of the Giants",
    "Battle Pack 2: War of the Giants Round 2",
    "Battle Pack 3: Monster League",
    "Battle Pack Tournament Prize Cards",
    "Battle Pack: Epic Dawn",
    "Battles of Legend: Armageddon",
    "Battles of Legend: Chapter 1",
    "Battles of Legend: Crystal Revenge",
    "Battles of Legend: Glorious Gallery",
    "Battles of Legend: Hero's Revenge",
    "Battles of Legend: Light's Revenge",
    "Battles of Legend: Monster Mayhem",
    "Battles of Legend: Monstrous Revenge",
    "Battles of Legend: Relentless Revenge",
    "Battles of Legend: Terminal Revenge",
    "Beyond the Brave",
    "Blazing Dominion",
    "Blazing Vortex",
    "Bonds Beyond Time Movie Pack",
    "Breakers of Shadow",
    "Breakers of Shadow: Special Edition",
    "Brothers of Legend",
    "Burst of Destiny",
    "Burst Protocol",
    "Capsule Monster Coliseum",
    "Champion Pack 1",
    "Champion Pack 2",
    "Champion Pack 3",
    "Champion Pack 4",
    "Champion Pack 5",
    "Champion Pack 6",
    "Champion Pack 7",
    "Champion Pack 8",
    "Chaos Impact",
    "Chaos Origins",
    "Circuit Break",
    "Clash of Rebellions",
    "Clash of Rebellions: Special Edition",
    "Code of the Duelist",
    "Collector's Boxes",
    "Cosmo Blazer",
    "Cosmo Blazer SE",
    "Crimson Crisis",
    "Crossed Souls",
    "Crossed Souls: Advanced Edition",
    "Crossover Breakers",
    "Crossroads of Chaos",
    "Cyberdark Impact",
    "Cybernetic Horizon",
    "Cybernetic Revolution",
    "Cyberstorm Access",
    "Dark Beginning 1",
    "Dark Beginning 2",
    "Dark Crisis",
    "Dark Crisis (25th Anniversary Edition)",
    "Dark Crisis (Worldwide English)",
    "Dark Duel Stories",
    "Dark Legends",
    "Dark Legends Promo Card",
    "Dark Neostorm",
    "Dark Revelation Volume 1",
    "Dark Revelation Volume 2",
    "Dark Revelation Volume 3",
    "Dark Revelation Volume 4",
    "Dark Saviors",
    "Darkwing Blast",
    "Dawn of Destiny Xbox",
    "Dawn of Majesty",
    "Demo Deck 2015",
    "Demo Deck 2016",
    "Demo Pack",
    "Destiny Board Traveler Promo",
    "Destiny Soldiers",
    "Dimension Force",
    "Dimension of Chaos",
    "Doom of Dimensions",
    "Dragons of Legend",
    "Dragons of Legend 2",
    "Dragons of Legend: The Complete Series",
    "Dragons of Legend: Unleashed",
    "Duel Devastator",
    "Duel Disk - Yusei Version",
    "Duel Master's Guide",
    "Duel Overload",
    "Duel Power",
    "Duel Terminal",
    "Duel Terminal - Preview",
    "Duel Terminal 1",
    "Duel Terminal 2",
    "Duel Terminal 3",
    "Duel Terminal 4",
    "Duel Terminal 5",
    "Duel Terminal 6",
    "Duel Terminal 7",
    "Duel Transer Promo Cards",
    "Duelist Alliance",
    "Duelist Alliance: Deluxe Edition",
    "Duelist Genesis",
    "Duelist League Demo 2010",
    "Duelist League Promo",
    "Duelist Nexus",
    "Duelist of the Roses",
    "Duelist Pack 10: Yusei 3",
    "Duelist Pack 11: Crow",
    "Duelist Pack 1: Jaden Yuki",
    "Duelist Pack 2: Chazz Princeton",
    "Duelist Pack 3: Jaden Yuki 2",
    "Duelist Pack 4: Zane Truesdale",
    "Duelist Pack 5: Aster Phoenix",
    "Duelist Pack 6: Jaden Yuki 3",
    "Duelist Pack 7",
    "Duelist Pack 7: Jesse Anderson",
    "Duelist Pack 8: Yusei Fudo",
    "Duelist Pack 9: Yusei 2",
    "Duelist Pack Collection Tin",
    "Duelist Pack Special Edition",
    "Duelist Pack: Battle City",
    "Duelist Pack: Dimensional Guardians",
    "Duelist Pack: Kaiba",
    "Duelist Pack: Rivals of the Pharaoh",
    "Duelist Pack: Yugi",
    "Duelist Revolution",
    "Duelist Revolution SE",
    "Duelist Saga",
    "Duelist's Advance",
    "Early Days Collection Promotional Cards",
    "eFootball Collaboration Promos",
    "Egyptian God Deck: Obelisk the Tormentor",
    "Egyptian God Deck: Slifer the Sky Dragon",
    "Elemental Energy",
    "Elemental Hero Collection 1",
    "Elemental Hero Collection 2",
    "Enemy of Justice",
    "Eternal Duelist Soul",
    "Eternity Code",
    "Event Pack Speed Duel",
    "Exclusive Tin 2009",
    "Extreme Force",
    "Extreme Victory",
    "Fire Fists Special Editon",
    "Fists of the Gadgets",
    "Flames of Destruction",
    "Flaming Eternity",
    "Forbidden Legacy",
    "Forbidden Legacy 1",
    "Forbidden Memories",
    "Force of the Breaker",
    "Fusion Enforcers",
    "Galactic Overlord",
    "Generation Force",
    "Generation Force SE",
    "Genesis Impact",
    "Ghosts From the Past",
    "Ghosts From the Past: The 2nd Haunting",
    "Gladiator's Assault",
    "Gladiator's Assault SE",
    "Glorious Victors",
    "Gold Series 2",
    "Gold Series 2008",
    "Gold Series 2009",
    "Gold Series 3",
    "Gold Series 4: Pyramids Edition",
    "Gold Series: Haunted Mine",
    "GX Duel Academy GBA Promo",
    "GX Next Generation Blister Pack Promo",
    "GX Spirit Caller Promo",
    "GX Tag Force 2 Promo",
    "GX Tag Force Promo",
    "GX Ultimate Beginner's Pack 1",
    "Hidden Arsenal",
    "Hidden Arsenal 2",
    "Hidden Arsenal 3",
    "Hidden Arsenal 4",
    "Hidden Arsenal 5: Steelswarm Invasion",
    "Hidden Arsenal 5: Steelswarm Invasion SE",
    "Hidden Arsenal 6: Omega Xyz",
    "Hidden Arsenal 7: Knight of Stars",
    "Hidden Arsenal: Chapter 1",
    "Hidden Arsenal: Special Edition",
    "Hidden Summoners",
    "High-Speed Riders",
    "Hobby League 1",
    "Hobby League 2",
    "Hobby League 3",
    "Hobby League 4",
    "Hobby League 5",
    "Hobby League 6",
    "Hobby League 7",
    "Ignition Assault",
    "Invasion of Chaos",
    "Invasion of Chaos (25th Anniversary Edition)",
    "Invasion of Chaos (Worldwide English)",
    "Invasion: Vengeance",
    "Invasion: Vengeance: Special Edition",
    "Judge Promotional Cards",
    "Judgment of the Light",
    "Judgment of the Light: Deluxe Edition",
    "Jump Award",
    "Justice Hunters",
    "King of Games: Yugi's Legendary Decks",
    "King of Games: Yugi's Legendary Decks (2020 Date Reprint)",
    "King's Court",
    "Labyrinth of Nightmare",
    "Labyrinth of Nightmare (Worldwide English)",
    "Labyrinth_of_Nightmare",
    "Legacy of Darkness",
    "Legacy of Darkness (Worldwide English)",
    "Legacy of Destruction",
    "Legacy of the Valiant",
    "Legend of Blue Eyes White Dragon (25th Anniversary Edition)",
    "Legend of Blue Eyes White Dragon (Worldwide English)",
    "Legendary 5D's Decks",
    "Legendary Arc-V Decks",
    "Legendary Collection 1",
    "Legendary Collection 2",
    "Legendary Collection 3: Yugi's World",
    "Legendary Collection 4: Joey's World",
    "Legendary Collection 5D's",
    "Legendary Collection Kaiba",
    "Legendary Collection Kaiba (2020 Date Reprint)",
    "Legendary Collection: 25th Anniversary Edition",
    "Legendary Decks II",
    "Legendary Decks II (2020 Reprint)",
    "Legendary Dragon Decks",
    "Legendary Dragon Decks (2020 Date Reprint)",
    "Legendary Duelists",
    "Legendary Duelists: Ancient Millennium",
    "Legendary Duelists: Duels From the Deep",
    "Legendary Duelists: Immortal Destiny",
    "Legendary Duelists: Magical Hero",
    "Legendary Duelists: Rage of Ra",
    "Legendary Duelists: Season 1",
    "Legendary Duelists: Season 2",
    "Legendary Duelists: Season 3",
    "Legendary Duelists: Sisters of the Rose",
    "Legendary Duelists: Soulburning Volcano",
    "Legendary Duelists: Synchro Storm",
    "Legendary Duelists: White Dragon Abyss",
    "Legendary Hero Decks",
    "Legendary Modern Decks 2026",
    "Light and Darkness Power Pack",
    "Light of Destruction",
    "Light of Destruction (2020 Date Reprint)",
    "Lightning Overdrive",
    "Limited Pack World Championship 2025",
    "Limited Pack World Championship 2026",
    "Lord of the Tachyon Galaxy",
    "Lost Millennium SE",
    "Magic Ruler",
    "Magician's Force",
    "Magnificent Maestros",
    "Magnificent Mavens",
    "Magnificent Monsters",
    "Master Collection Volume 1",
    "Master Collection Volume 2",
    "Mattel Action Figure Promos: Series 1",
    "Mattel Action Figure Promos: Series 2",
    "Mattel Action Figure Promos: Series 3",
    "Maximum Crisis",
    "Maximum Gold",
    "Maximum Gold: El Dorado",
    "Maze of Memories",
    "Maze of Millennia",
    "Maze of Muertos",
    "Maze of the Master",
    "McDonald's Promo",
    "McDonald's Promo Series 2",
    "Metal Raiders",
    "Metal Raiders (25th Anniversary Edition)",
    "Metal Raiders (Worldwide English)",
    "Millennium Pack",
    "Miscellaneous Promotional Cards",
    "Mystic Fighters",
    "Nintendo DS Nightmare of Troubadour",
    "Noble Knights of the Round Table Box Set",
    "Number Hunters",
    "Order of Chaos",
    "Order of Chaos SE",
    "OTS Tournament Pack 1",
    "OTS Tournament Pack 10",
    "OTS Tournament Pack 11",
    "OTS Tournament Pack 12",
    "OTS Tournament Pack 13",
    "OTS Tournament Pack 14",
    "OTS Tournament Pack 15",
    "OTS Tournament Pack 16",
    "OTS Tournament Pack 17",
    "OTS Tournament Pack 18",
    "OTS Tournament Pack 19",
    "OTS Tournament Pack 2",
    "OTS Tournament Pack 20",
    "OTS Tournament Pack 21",
    "OTS Tournament Pack 22",
    "OTS Tournament Pack 23",
    "OTS Tournament Pack 24",
    "OTS Tournament Pack 25",
    "OTS Tournament Pack 26",
    "OTS Tournament Pack 27",
    "OTS Tournament Pack 28",
    "OTS Tournament Pack 29",
    "OTS Tournament Pack 3",
    "OTS Tournament Pack 30",
    "OTS Tournament Pack 4",
    "OTS Tournament Pack 5",
    "OTS Tournament Pack 6",
    "OTS Tournament Pack 7",
    "OTS Tournament Pack 8",
    "OTS Tournament Pack 9",
    "Pendulum Evolution",
    "Phantom Darkness",
    "Phantom Nightmare",
    "Phantom Rage",
    "Phantom Revenge",
    "Pharaoh Tour Promos",
    "Pharaoh's Servant",
    "Pharaoh's Servant (25th Anniversary Edition)",
    "Pharaoh's Servant (Worldwide English)",
    "Pharaonic Guardian",
    "Photon Hypernova",
    "Photon Shockwave",
    "Poseidra Value Box",
    "Power of Chaos: Joey the Passion",
    "Power of Chaos: Kaiba the Revenge",
    "Power of Chaos: Yugi the Destiny",
    "Power of the Duelist",
    "Power of the Elements",
    "Premium Gold",
    "Premium Gold: Infinite Gold",
    "Premium Gold: Return of the Bling",
    "Premium Pack 1",
    "Premium Pack 2",
    "Primal Origin",
    "PS2 Yugioh GX The Beginning of Destiny",
    "Quarter Century Bonanza",
    "Quarter Century Stampede",
    "Ra Yellow Mega Pack",
    "Ra Yellow Mega Pack SE",
    "Rage of the Abyss",
    "Raging Battle",
    "Raging Battle SE",
    "Raging Tempest",
    "Raging Tempest: Special Edition",
    "Rarity Collection 5",
    "Redemption Replacement",
    "Reshef of Destruction",
    "Retro Pack",
    "Retro Pack (2020 Date Reprint)",
    "Retro Pack 2",
    "Retro Pack 2 (2020 Date Reprint)",
    "Return of the Duelist",
    "Return of the Duelist SE",
    "Rise of Destiny",
    "Rise of Destiny Special Edition",
    "Rise of the Duelist",
    "Rising Rampage",
    "Samurai Assault",
    "Savage Strike",
    "Secret Slayers",
    "Secrets of Eternity",
    "Shadow of Infinity",
    "Shadow Samurai Value Box",
    "Shadow Specters",
    "Shadows in Valhalla",
    "Shining Victories",
    "Shining Victories: Special Edition",
    "Shonen Jump Championship Series Prize Cards",
    "Shonen Jump Championship Series Promos",
    "Shonen Jump Magazine Promos",
    "Silver Dragon Value Box",
    "Sneak Preview Series 1",
    "Sneak Preview Series 2",
    "Sneak Preview Series 3",
    "Sneak Preview Series 4",
    "Sneak Preview Series 5",
    "Soul Fusion",
    "Soul of the Duelist",
    "Speed Duel Decks: Destiny Masters",
    "Speed Duel Decks: Duelists of Tomorrow",
    "Speed Duel Decks: Match of the Millennium",
    "Speed Duel Decks: Twisted Nightmares",
    "Speed Duel Decks: Ultimate Predators",
    "Speed Duel Demo Deck",
    "Speed Duel Demo Deck 2020",
    "Speed Duel GX: Duel Academy Box",
    "Speed Duel GX: Duelists of Shadows",
    "Speed Duel GX: Midterm Destruction",
    "Speed Duel GX: Midterm Paradox",
    "Speed Duel: Arena of Lost Souls",
    "Speed Duel: Attack from the Deep",
    "Speed Duel: Battle City Box",
    "Speed Duel: Battle City Finals",
    "Speed Duel: Scars of Battle",
    "Speed Duel: Streets of Battle City",
    "Speed Duel: Tournament Pack 1",
    "Speed Duel: Tournament Pack 2",
    "Speed Duel: Tournament Pack 3",
    "Speed Duel: Tournament Pack 4",
    "Speed Duel: Tournament Pack 5",
    "Speed Duel: Tournament Pack 6",
    "Speed Duel: Tournament Pack 7",
    "Speed Duel: Trials of the Kingdom",
    "Spell Ruler",
    "Spell Ruler (25th Anniversary Edition)",
    "Spell Ruler (Worldwide English)",
    "Spirit Warriors",
    "Stairway to the Destined Duel",
    "Star Pack - Battle Royal",
    "Star Pack 2013",
    "Star Pack 2014",
    "Star Pack ARC-V",
    "Star Pack VRAINS",
    "Stardust Accelerator Promos",
    "Stardust Overdrive",
    "Starstrike Blast",
    "Starter Deck 2006",
    "Starter Deck: Codebreaker",
    "Starter Deck: Dark Legion",
    "Starter Deck: Dawn of the Xyz",
    "Starter Deck: Duelist Toolbox",
    "Starter Deck: Jaden Yuki",
    "Starter Deck: Joey",
    "Starter Deck: Kaiba",
    "Starter Deck: Kaiba Evolution",
    "Starter Deck: Kaiba Reloaded",
    "Starter Deck: Link Strike",
    "Starter Deck: Pegasus",
    "Starter Deck: Saber Force",
    "Starter Deck: Syrus Truesdale",
    "Starter Deck: Xyz Symphony",
    "Starter Deck: Yugi",
    "Starter Deck: Yugi Evolution",
    "Starter Deck: Yugi Reloaded",
    "Starter Deck: Yuya",
    "Storm of Ragnarok",
    "Storm of Ragnarok SE",
    "Strike of Neos",
    "Structure Deck: Albaz Strike",
    "Structure Deck: Beware of Traptrix",
    "Structure Deck: Blaze of Destruction",
    "Structure Deck: Blue-Eyes White Destiny",
    "Structure Deck: Cyber Dragon Revolution",
    "Structure Deck: Cyber Strike",
    "Structure Deck: Cyberse Link",
    "Structure Deck: Dark World",
    "Structure Deck: Deluxe Edition",
    "Structure Deck: Dinosaur's Rage",
    "Structure Deck: Dinosmasher's Fury",
    "Structure Deck: Dragon's Roar",
    "Structure Deck: Dragons Collide",
    "Structure Deck: Dragunity Legion",
    "Structure Deck: Emperor of Darkness",
    "Structure Deck: Fire Kings",
    "Structure Deck: Freezing Chains",
    "Structure Deck: Fury from the Deep",
    "Structure Deck: Gates of the Underworld",
    "Structure Deck: Geargia Rampage",
    "Structure Deck: HERO Strike",
    "Structure Deck: Invincible Fortress",
    "Structure Deck: Lair of Darkness",
    "Structure Deck: Legend of the Crystal Beasts",
    "Structure Deck: Lord of the Storm",
    "Structure Deck: Lost Sanctuary",
    "Structure Deck: Machina Mayhem",
    "Structure Deck: Machine Re-Volt",
    "Structure Deck: Machine Reactor",
    "Structure Deck: Marik",
    "Structure Deck: Master of Pendulum",
    "Structure Deck: Mechanized Madness",
    "Structure Deck: Onslaught of the Fire Kings",
    "Structure Deck: Order of the Spellcasters",
    "Structure Deck: Pendulum Domination",
    "Structure Deck: Powercode Link",
    "Structure Deck: Realm of Light",
    "Structure Deck: Realm of Light (2020 Date Reprint)",
    "Structure Deck: Realm of the Sea Emperor",
    "Structure Deck: Rise of the Dragon Lords",
    "Structure Deck: Rise of the True Dragons",
    "Structure Deck: Rokket Revolt",
    "Structure Deck: Sacred Beasts",
    "Structure Deck: Saga of Blue Eyes White Dragon (2020 Date Reprint)",
    "Structure Deck: Saga of Blue-Eyes White Dragon",
    "Structure Deck: Samurai Warlords",
    "Structure Deck: Seto Kaiba",
    "Structure Deck: Shaddoll Showdown",
    "Structure Deck: Soulburner",
    "Structure Deck: Spellcaster's Command",
    "Structure Deck: Spellcaster's Judgment",
    "Structure Deck: Spirit Charmers",
    "Structure Deck: Synchron Extreme",
    "Structure Deck: The Crimson King",
    "Structure Deck: The Dark Emperor",
    "Structure Deck: Warrior's Triumph",
    "Structure Deck: Warriors' Strike",
    "Structure Deck: Wave of Light",
    "Structure Deck: Yugi Muto",
    "Structure Deck: Zombie Horde",
    "Structure Deck: Zombie Madness",
    "Structure Deck: Zombie World",
    "Super Starter: Space-Time Showdown",
    "Super Starter: Space-Time Showdown Power-Up Pack",
    "Super Starter: V for Victory",
    "Super Starter: V for Victory Power-Up Pack",
    "Supreme Darkness",
    "Tactical Evolution",
    "Tactical Evolution: Special Edition",
    "Tactical Masters",
    "THE CHRONICLES DECK: Spirit Charmers (All-Foil Edition)",
    "THE CHRONICLES DECK: The Fallen & The Virtuous (All-Foil Edition)",
    "The Dark Illusion",
    "The Dark Illusion: Special Edition (EU)",
    "The Dark Side of Dimensions Movie Pack",
    "The Dark Side of Dimensions Movie Pack: Gold Edition",
    "The Dark Side of Dimensions Movie Pack: Secret Edition",
    "The Dark Side of Dimensions Movie Pack: Special Edition",
    "The Duelist Genesis",
    "The Falsebound Kingdom",
    "The Grand Creators",
    "The Infinite Forbidden",
    "The Infinity Chasers",
    "The Legend of Blue Eyes White Dragon",
    "The Lost Art Promotion",
    "The Lost Millennium",
    "The New Challengers",
    "The New Challengers: Super Edition",
    "The Pot Collection",
    "The Sacred Cards",
    "The Secret Forces",
    "The Shining Darkness",
    "The Valuable Book Volume 5",
    "Toon Chaos",
    "Tournament Pack 1",
    "Tournament Pack 2",
    "Tournament Pack 3",
    "Tournament Pack 4",
    "Tournament Pack 5",
    "Tournament Pack 6",
    "Tournament Pack 7",
    "Tournament Pack 8",
    "Toys \"R\" Us Throwdown Promo",
    "Turbo Pack Booster One Pack",
    "Turbo Pack: Booster Eight",
    "Turbo Pack: Booster Five",
    "Turbo Pack: Booster Four",
    "Turbo Pack: Booster Seven",
    "Turbo Pack: Booster Six",
    "Turbo Pack: Booster Three",
    "Turbo Pack: Booster Two",
    "Twilight Edition",
    "Ultimate Edition 2",
    "Ultimate Tournament Pack 1",
    "Ultimate Tournament Pack 2",
    "Valiant Smashers",
    "Wild Survivors",
    "Wing Raiders",
    "Winner's Pack 2026-2027",
    "World Championship 2004: GBA Promo",
    "World Championship 2005: 7 Trials to Glory",
    "World Championship 2006: Ultimate Masters",
    "World Championship 2007",
    "World Championship 2008",
    "World Championship 2010 Card Pack",
    "World Championship 2011 Card Pack",
    "World Championship JPP Cards",
    "World Championship Series",
    "World Superstars",
    "X-Saber Power-Up",
    "Yu-Gi-Oh! 5D's Manga Promotional Cards",
    "Yu-Gi-Oh! 5D's Over the Nexus Promo Cards",
    "Yu-Gi-Oh! 5D's Tag Force 4 Promo",
    "Yu-Gi-Oh! 5D's Tag Force Promotional Cards",
    "Yu-Gi-Oh! 5D's Wheelie Breakers Promotional Cards",
    "Yu-Gi-Oh! ARC-V Promo Cards",
    "Yu-Gi-Oh! Championship Series 2025 Prize Cards",
    "Yu-Gi-Oh! Championship Series Prize Cards",
    "Yu-Gi-Oh! Day Promos",
    "Yu-Gi-Oh! Duel Monsters International: Worldwide Edition",
    "Yu-Gi-Oh! GX Manga Promotional Cards",
    "Yu-Gi-Oh! GX Tag Force Evolution Promo",
    "Yu-Gi-Oh! GX Tag Force Promotional Cards",
    "Yu-Gi-Oh! Movie Exclusive Pack",
    "Yu-Gi-Oh! R Manga Promo",
    "Yu-Gi-Oh! The Movie Ani-Manga Promo",
    "Yu-Gi-Oh! The Movie Promo Set",
    "Yu-Gi-Oh! Tokens",
    "Yu-Gi-Oh! Value Boxes",
    "Yu-Gi-Oh! Video Game Promotional Cards",
    "Yu-Gi-Oh! ZEXAL Manga Promotional Cards",
    "Yu-Gi-Oh! ZEXAL World Duel Carnival Promos",
    "Yugioh 5D's 2008 Starter Deck",
  ],

  LORCANA_RARITIES: [
    "Common",
    "Uncommon",
    "Rare",
    "Super Rare",
    "Legendary",
    "Epic",
    "Enchanted",
    "Iconic",
    "Promo",
  ],

  LORCANA_CHARACTER_VERSIONS: [
    "Dreamborn",
    "Floodborn",
    "Storyborn",
  ],

  LORCANA_PROPERTIES: [
    "101 Dalmatians",
    "A Goofy Movie",
    "Aladdin",
    "Alice in Wonderland",
    "Atlantis: The Lost Empire",
    "Bambi",
    "Beauty and the Beast",
    "Big Hero 6",
    "Bolt",
    "Brave",
    "Brave Little Tailor",
    "Brother Bear",
    "Chip 'n' Dale: Rescue Rangers",
    "Cinderella",
    "Darkwing Duck",
    "DuckTales",
    "Dumbo",
    "Encanto",
    "Fantasia",
    "Frozen",
    "Gargoyles",
    "Hercules",
    "Lady and the Tramp",
    "Lilo & Stitch",
    "Lorcana",
    "Mickey and the Beanstalk",
    "Mickey Mouse & Friends",
    "Mickey, Donald, Goofy: The Three Musketeers",
    "Mickey's Christmas Carol",
    "Moana",
    "Monsters, Inc.",
    "Mulan",
    "Peter Pan",
    "Pinocchio",
    "Pocahontas",
    "Ravensburger",
    "Raya and the Last Dragon",
    "Robin Hood",
    "Sleeping Beauty",
    "Snow White and the Seven Dwarfs",
    "Standard",
    "TaleSpin",
    "Tangled",
    "The Aristocats",
    "The Black Cauldron",
    "The Emperor's New Groove",
    "The Fox and the Hound",
    "The Great Mouse Detective",
    "The Incredibles",
    "The Jungle Book",
    "The Legend of Sleepy Hollow",
    "The Lion King",
    "The Little Mermaid",
    "The Princess and the Frog",
    "The Rescuers",
    "The Sword in the Stone",
    "Toy Story",
    "Treasure Planet",
    "Up",
    "Winnie the Pooh",
    "Wreck-It Ralph",
    "Zootopia",
  ],

  LORCANA_INK_COLORS: [
    "Amber",
    "Amethyst",
    "Emerald",
    "Ruby",
    "Sapphire",
    "Steel",
  ],

  LORCANA_FOIL_TYPES: [
    "Normal",
    "Cold Foil",
    "Holofoil",
  ],

  SEALED_PRODUCT_TYPES: {
    Pokemon: [
      "Booster Box","Booster Pack","Elite Trainer Box (ETB)",
      "Collector's Box","Premium Collection","Special Collection",
      "Tin","Blister Pack","Bundle","3-Pack Blister","Trainer Kit",
      "Build & Battle Box","Mini Tin","Gift Box","Holiday Bundle",
      "Advent Calendar","Battle Academy","Theme Deck","V Battle Deck",
      "ex Box","Starter Deck","Display Box","Japanese Booster Box",
      "Japanese Booster Pack","Japanese Gift Box",
    ],
    Lorcana: [
      "Player Starter Set",
      "Playmats",
      "Booster Display",
      "Booster Pack",
      "Collection Starter Set",
      "Disney Lorcana Gateway",
      "Gift Box",
      "Gift Set",
      "Illumineer's Quest",
      "Illumineer's Trove",
      "Single-Player Deck",
      "Sleeved Booster Pack",
      "Starter Deck",
    ],
  },

};

export default CONFIG;
